export function getCookie(cname) {
	var cookieRegex = new RegExp("^(?:.*;)?\\s*"+cname+"\\s*=\\s*([^;]+)(?:.*)?$");
	return (document.cookie.match(cookieRegex)||[null,null])[1];
	//return (document.cookie.match(/^(?:.*;)?\s*cg-force-desktop-mode\s*=\s*([^;]+)(?:.*)?$/)||[,null])[1];
}
